import Therapists from './Therapists'
export default Therapists
